// extracted by mini-css-extract-plugin
export default {"Header__Section":"Security_Header__Section__AR33Z","Security__Page__Section":"Security_Security__Page__Section__1y4MZ","Page__Title":"Security_Page__Title__YwlbK"};